import React from "react";
import { CryptoDepositHistory } from "./CryptoDepositSections";
import { formatDate, getHistoryStatus } from "./financeWallet.helpers";

const WalletHistorySection = ({
  canDeleteHistory = false,
  canDeleteAll = canDeleteHistory,
  currentPage,
  getDeleteId,
  historyCount,
  historyRows,
  historySkeletonRows,
  historyTitle,
  isCryptoHistory,
  isDeletePending = false,
  isLoading,
  onDeleteAll,
  onDeleteRow,
  onNextPage,
  onPreviousPage,
  renderAmount,
  renderLabel,
  totalPages,
}) => (
  <section className="wallet-history">
    <div className="wallet-history-header">
      <h4>{historyTitle}</h4>
      <div className="wallet-history-header-actions">
        <span>{historyCount ? `${historyCount}건` : ""}</span>
        {canDeleteAll && historyRows.length ? (
          <button type="button" onClick={onDeleteAll} disabled={isDeletePending || isLoading}>
            전체 삭제
          </button>
        ) : null}
      </div>
    </div>

    {isCryptoHistory ? (
      <CryptoDepositHistory
        historyRows={historyRows}
        historySkeletonRows={historySkeletonRows}
        isLoading={isLoading}
      />
    ) : (
      <div className="wallet-history-table">
        <div className={`wallet-history-row is-head ${canDeleteHistory ? "has-delete-action" : ""}`}>
          <span data-label="구분">구분</span>
          <span data-label="시간">시간</span>
          <span data-label="금액">금액</span>
          <span data-label="상태">상태</span>
          {canDeleteHistory ? <span data-label="관리">관리</span> : null}
        </div>

        {isLoading ? (
          Array.from({ length: historySkeletonRows }).map((_, index) => (
            <div
              className={`wallet-history-row is-skeleton ${canDeleteHistory ? "has-delete-action" : ""}`}
              role="status"
              aria-label="내역 불러오는 중"
              key={`wallet-skeleton-${index}`}
            >
              <i />
              <i />
              <i />
              <i />
              {canDeleteHistory ? <i /> : null}
            </div>
          ))
        ) : historyRows.length ? (
          historyRows.map((row, index) => {
            const status = getHistoryStatus(row);
            const deleteId = getDeleteId?.(row);
            const deleteDetailId = `wallet-history-delete-detail-${currentPage}-${index}`;
            return (
              <div
                className={`wallet-history-row ${canDeleteHistory ? "has-delete-action" : ""}`}
                key={deleteId ?? row?.id ?? row?._id ?? index}
              >
                <span data-label="구분">{renderLabel(row)}</span>
                <span data-label="시간">{formatDate(row)}</span>
                <span data-label="금액">{renderAmount(row)}</span>
                <span data-label="상태" className={status.className}>
                  {status.label}
                </span>
                {canDeleteHistory ? (
                  <span data-label="관리" className="wallet-history-delete-cell">
                    {deleteId !== null && deleteId !== undefined ? (
                      <>
                        <span className="wallet-sr-only" id={deleteDetailId}>
                          {renderAmount(row)}, {formatDate(row)}
                        </span>
                        <button
                          type="button"
                          aria-label={`${renderLabel(row)} 내역 삭제`}
                          aria-describedby={deleteDetailId}
                          onClick={() => onDeleteRow(row, deleteId)}
                          disabled={isDeletePending}
                        >
                          삭제
                        </button>
                      </>
                    ) : null}
                  </span>
                ) : null}
              </div>
            );
          })
        ) : (
          <div className="wallet-empty-history">표시할 내역이 없습니다.</div>
        )}
      </div>
    )}

    <div
      className={`wallet-history-pager ${totalPages > 1 ? "" : "is-hidden"}`}
      aria-hidden={totalPages <= 1}
    >
      {totalPages > 1 ? (
        <>
          <button
            type="button"
            aria-label="이전 페이지"
            disabled={currentPage <= 1 || isLoading}
            onClick={onPreviousPage}
          >
            ‹
          </button>
          <span>
            {currentPage} / {totalPages}
          </span>
          <button
            type="button"
            aria-label="다음 페이지"
            disabled={currentPage >= totalPages || isLoading}
            onClick={onNextPage}
          >
            ›
          </button>
        </>
      ) : (
        <span>1 / 1</span>
      )}
    </div>
  </section>
);

export default WalletHistorySection;
